import { DataType } from './data-type';

/**
 * Saved-query payload types served by dash-meta / report-builder APIs.
 * Kept here so `libs/core` stays independent of Nest apps.
 */
export type SavedQueryDataType =
  | 'ONE_DIMENSION'
  | 'TWO_DIMENSION'
  | 'TIMESERIES'
  | 'MAP'
  | 'TABLE';

export const SAVED_QUERY_DATA_TYPE_TO_DATA_TYPE: Record<
  SavedQueryDataType,
  DataType
> = {
  ONE_DIMENSION: DataType.SINGLE,
  TWO_DIMENSION: DataType.BREAKDOWN_SINGLE,
  TIMESERIES: DataType.TIMESERIES,
  MAP: DataType.MAP,
  TABLE: DataType.TABLE_ROWS,
};

/**
 * Maps a DataType to Snowflake saved-query `dataType` values that can
 * materialize that shape in the custom-query pipeline.
 */
export function dataTypeToSavedQueryDataTypes(
  dataType: DataType
): SavedQueryDataType[] {
  switch (dataType) {
    case DataType.SINGLE:
      return ['ONE_DIMENSION'];
    case DataType.BREAKDOWN_SINGLE:
    case DataType.FLOW_BREAKDOWN_SINGLE:
      return ['TWO_DIMENSION'];
    case DataType.TIMESERIES:
    case DataType.BREAKDOWN_TIMESERIES:
      return ['TIMESERIES'];
    case DataType.MAP:
      return ['MAP'];
    case DataType.TABLE_ROWS:
      return ['TABLE', 'ONE_DIMENSION', 'TWO_DIMENSION', 'TIMESERIES', 'MAP'];
    case DataType.BOX:
    case DataType.DISTRIBUTION:
    case DataType.TEXT:
      return [];
  }
}

export function savedQueryDataTypeToDataType(
  savedQueryDataType: SavedQueryDataType
): DataType {
  return SAVED_QUERY_DATA_TYPE_TO_DATA_TYPE[savedQueryDataType];
}

/** Resolves the DataType for a Snowflake saved query from {@link SavedQueryDataType}. */
export function resolveSnowflakeDataType(
  savedQueryDataType: SavedQueryDataType
): DataType {
  if (savedQueryDataType === 'TWO_DIMENSION') {
    return DataType.BREAKDOWN_SINGLE;
  }

  return savedQueryDataTypeToDataType(savedQueryDataType);
}
